<div class="dialog-title-row">
  <h2 mat-dialog-title>{{ data.broker ? 'Edit Broker' : 'Add Broker' }}</h2>
  <button type="button" mat-icon-button aria-label="Close dialog" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<p class="dialog-subtitle">Enter broker details and assign benefit categories. Each category can only belong to one broker, and any conflicts will be reviewed before saving.</p>

<mat-dialog-content>
  <form [formGroup]="form" class="broker-form">
    <section class="section-block">
      <h3 class="section-title">BROKER INFORMATION</h3>

      <div class="field-grid one-col">
        <mat-form-field appearance="outline">
          <mat-label>Broker Company Name</mat-label>
          <input matInput formControlName="companyName" placeholder="Enter broker company name" />
          <mat-error *ngIf="form.get('companyName')?.hasError('required')">
            Broker company name is required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Contact Name</mat-label>
          <input matInput formControlName="contactName" placeholder="Enter contact name" />
          <mat-error *ngIf="form.get('contactName')?.hasError('required')">
            Contact name is required
          </mat-error>
        </mat-form-field>
      </div>

      <div class="field-grid two-col">
        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" placeholder="Enter email" />
          <mat-error *ngIf="form.get('email')?.hasError('required')">
            Email is required
          </mat-error>
          <mat-error *ngIf="form.get('email')?.hasError('email')">
            Enter a valid email address
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Phone</mat-label>
          <input matInput formControlName="phone" placeholder="(555) 123-4567" inputmode="tel" (input)="onPhoneInput()" />
          <mat-error *ngIf="form.get('phone')?.hasError('usPhone') && (form.get('phone')?.dirty || form.get('phone')?.touched)">
            Enter a valid 10-digit US phone number
          </mat-error>
        </mat-form-field>
      </div>
    </section>

    <section class="section-block">
      <div class="section-title-row">
        <h3 class="section-title">BENEFIT CATEGORIES *</h3>
        <div class="category-actions">
          <button mat-button type="button" (click)="selectAllCategories()">Select All</button>
          <button mat-button type="button" (click)="clearCategories()">Clear</button>
        </div>
      </div>

      <p class="section-help">Select which benefit categories this broker will represent. Categories can only be assigned to one broker at a time.</p>

      <div class="categories-grid">
        <button
          *ngFor="let category of categories"
          mat-stroked-button
          type="button"
          class="category-btn"
          [class.selected]="hasCategory(category)"
          [class.conflicted]="hasCategoryConflict(category)"
          (click)="toggleCategory(category)"
        >
          <span class="category-btn-inner">
            <span class="checkbox-box" [class.checked]="hasCategory(category)"></span>
            <span class="category-content">
              <span class="category-label">{{ category }}</span>
              <span class="category-conflict-label" *ngIf="hasCategoryConflict(category)">
                {{ getCategoryConflictLabel(category) }}
              </span>
            </span>
          </span>
        </button>
      </div>

      <div class="inline-conflicts" *ngIf="selectedCategoryConflicts.length > 0">
        <div class="inline-conflicts-alert">
          <mat-icon class="inline-conflicts-icon">warning_amber</mat-icon>
          <div class="inline-conflicts-copy">
            <div class="inline-conflicts-title">Assignment Conflicts Need Review</div>
            <p class="inline-conflicts-help">
              These selected categories already belong to another broker. Saving will reassign them to this broker.
            </p>
          </div>
        </div>

        <div class="inline-conflict-card" *ngFor="let conflict of selectedCategoryConflicts">
          <div class="inline-conflict-copy">
            <div class="inline-conflict-category">{{ conflict.category }}</div>
            <div class="inline-conflict-current">
              Will be reassigned from {{ conflict.currentBrokerName }} to {{ conflict.newBrokerName || 'this broker' }}
            </div>
          </div>
        </div>

        <mat-checkbox class="inline-conflicts-confirm" formControlName="confirmReassignments" tabindex="0">
          I understand these categories will be reassigned to this broker when I save.
        </mat-checkbox>

        <div class="category-error" *ngIf="showConflictConfirmationError">
          Confirm that you want to reassign these categories before saving
        </div>
      </div>

      <div class="category-error" *ngIf="showCategoriesError">
        Select at least one benefit category
      </div>
    </section>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="footer-actions">
  <button type="button" mat-button (click)="close()">Cancel</button>
  <button type="button" mat-raised-button color="primary" (click)="save()">
    {{ data.broker ? 'Save Broker' : 'Add Broker' }}
  </button>
</mat-dialog-actions>
